export default "__VITE_ASSET__09b228a9__"